import { render } from "./ParticipantItemRenderer.vue?vue&type=template&id=c2121264"
import script from "./ParticipantItemRenderer.vue?vue&type=script&lang=js"
export * from "./ParticipantItemRenderer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__